module.exports = __webpack_public_path__ + "506078c319089e31955c3d605f6c9e80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error.png
// module id = 414
// module chunks = 1